import { Forms, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSuccess, toggleFormHelp } from 'actions/ui';
import { apiPatch } from 'services';
import { setUserAvatar } from 'actions/user';
import posthog from 'posthog-js';

export const EditGoals = ({ show, onClose, profile }) => {
    const dispatch = useDispatch();

    const [saving, setSaving] = React.useState(false);
    const [goals, setGoals] = React.useState('');

    const user = useSelector(state => state.user.user);
    const { tags, handles } = useSelector(state => state.ui);

    React.useEffect(() => {
        if (show) {
            setGoals(profile?.goals);
        }
    }, [show, profile]);

    const st = (path, ...rest) => SystemText(`User121/PersonalGoals/Edit/${path}`, ...rest);

    const save = () => {
        profile.goals = goals;

        apiPatch('profile-goals', profile, user.guid, () => {
            dispatch(setShowSuccess(st('Success')));
            dispatch(setUserAvatar(profile.avatar));
            posthog.capture('personal-goals-saved');
            setSaving(false);
            onClose();
        });
    };

    const footer = (
        <div>
            <SaveButton
                id="image-save-button"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={save}
            >
                {st('Buttons/Save')}
            </SaveButton>
            <button data-testid="image-cancel-button" className="btn" onClick={onClose}>
                {st('Buttons/Cancel')}
            </button>
        </div>
    );

    return (
        <Modal
            show={show}
            title={st('Title')}
            close={onClose}
            footer={footer}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
        >
            <Forms.Textarea
                help={st('Help')}
                placeholder={st('Placeholder')}
                rows="10"
                value={goals}
                onChange={setGoals}
                label={st('Label')}
                data-testid="text-goals"
                tags={tags}
                handles={handles}
            />
        </Modal>
    );
};

export default EditGoals;
